import DestinationDetails from './DestinationDetails';

export default DestinationDetails;
